import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddedPasskeyIllustration } from "../../../icons/illustrations/added-passkey.js";
import { useAuthContext } from "../context.js";
// eslint-disable-next-line jsdoc/require-jsdoc
export function PasskeyAdded() {
    const { setAuthStep } = useAuthContext();
    setTimeout(() => {
        setAuthStep({ type: "complete" });
    }, 5000);
    return (_jsxs("div", { className: "flex flex-col gap-5 items-center", children: [_jsx("div", { className: "flex flex-col items-center justify-center h-12 w-12", children: _jsx(AddedPasskeyIllustration, { height: "48", width: "48" }) }), _jsx("h3", { className: "font-semibold text-lg", children: "Passkey added!" }), _jsx("p", { className: "text-fg-secondary text-sm text-center", children: "You can use this passkey to sign in next time." })] }));
}
//# sourceMappingURL=passkey-added.js.map